module.exports = __webpack_public_path__ + "static/media/Fundacion.4825e665.webp";